import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../login/cliente_login";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { ListaDiccionaryEntity } from "../../../components/common/utils/entities/lista_dictionary_entity";
import { ContactosClienteEmpresaEntity } from "../entities/contactos_cliente_empresa_entity";


declare var jQuery: any;

@Injectable()
export class DatosGeneralesEmpresaService {
    usuario: ClienteLogin;
    userEmpresa: ClienteXCiudad;
    contactoCliEmpresa:ContactosClienteEmpresaEntity;
    datosGenelaresEmpresa:DatosGeneralesEntity;
    private url = "datosGeneralesEmpresa";

    constructor(public authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    datosGeneralesEmpresa(userEmpresa): Observable<DatosGeneralesEntity> {
        
        let body = JSON.stringify(userEmpresa);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarDatosGenerales", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    consultarDatosUsuario(userEmpresa): Observable<ContactosClienteEmpresaEntity> {
        
        let body = JSON.stringify(userEmpresa);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarDatosPorUsuario", body, options).map(this.extractData)
            .catch(this.handleError);
    }
     actualizarDatosUsuario(contactoCliEmpresa): Observable<boolean> {        
        let body = JSON.stringify(contactoCliEmpresa);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url +"/actualizarContactoEmpresa", body, options).map(this.extractData)
            .catch(this.handleError);
    }

      actualizarDatosGeneralesEmpresa(datosGenelaresEmpresa): Observable<boolean> {        
        let body = JSON.stringify(datosGenelaresEmpresa);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url +"/actualizarDatosEmpresa", body, options).map(this.extractData)
            .catch(this.handleError);
    }


    consultaActividadEconomica(): Observable<ListaDiccionaryEntity[]> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/consultaListaActEco", options).map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/datosGenerales/datos-generales-empresa.service.ts